import api from '@/api/index.js'

const account_discounts = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_ACCOUNT_DISCOUNTS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_ACCOUNT_DISCOUNTS: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_ACCOUNT_DISCOUNTS_ERROR: (state, error) => {
      state.error = error;
      state.loading = false;
    }
  },

  actions: {
    LoadAccountDiscounts({commit}, accountID) {
      commit('SET_ACCOUNT_DISCOUNTS_ERROR', null)
      commit('SET_ACCOUNT_DISCOUNTS_LOADING', true)
      return api.get(`accounts/${accountID}/discounts?limit=150&offset=0`)
        .then((response) => {
          commit('SET_ACCOUNT_DISCOUNTS', response)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_DISCOUNTS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    }
  },
}

export default account_discounts
